module.exports = __webpack_public_path__ + "img/serverless.10c76ec4.png";